import { URGENCY, STATUS_META } from "../../lib/format";
import { cn } from "../../lib/utils";

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || STATUS_META.disponible;
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium", m.cls)} data-testid={`status-badge-${status}`}>
      {m.label}
    </span>
  );
};

export const DeadlineBadge = ({ level, children }) => {
  const m = URGENCY[level] || URGENCY.neutral;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium", m.cls)}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
      {children || m.label}
    </span>
  );
};
